<template>
    <div class="container">
        <!--        切换登录方式-->
        <SwitchLoginMethod :show="this.showSwitchLoginMethod" @using-password="handleUsingPassword"
                           :initialMethodIsPassword="this.initialMethodIsPassword"></SwitchLoginMethod>
        <!--        人脸登录-->
        <template v-if="usingFace">
            <FaceLogin ref="faceLogin" @camera-opened="handleCameraOpened"
                       :identify-for="identifyFor"
                       @user-identified="userIdentified"></FaceLogin>
        </template>
        <!--        账户密码登录-->
        <template v-else>
            <PasswordLogin ref="passwordLogin" :showSubmitButton="showPasswordLoginButton"></PasswordLogin>
        </template>
        <ReBModal ref="verificationCode" header="安全验证" hide-footer close-on-click-modal no-close-on-backdrop>
            <EmVerificationCode :loginForm="loginForm"></EmVerificationCode>
        </ReBModal>
    </div>
</template>

<script>
import PasswordLogin from "@/components/em/login/PasswordLogin";
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import FaceLogin from "@/components/em/login/FaceLogin";
import SwitchLoginMethod from "@/components/em/login/SwitchLoginMethod";
import EmVerificationCode from "@/components/em/login/VerificationCode.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emLoginMixin from "@/mixin/em/common/stuffs/login/emLoginMixin";

const IDENTIFY_FOR = {
    LOGIN: 'login',
    TO_WORK: 'toWork'
}
export default {
    name: "Login",
    components: {PasswordLogin, SwitchLoginMethod, FaceLogin, EmVerificationCode, ReBModal},
    mixins: [emCommonListMixin, emCommonApiMixin, emLoginMixin],
    computed: {
        showSwitchLoginMethod() {
            // 当前不是人脸登录的方式，或者摄像头没打开
            return this.alwaysShowSwitch || (!this.usingFace || !this.cameraOpened);
        },
        agreementContentRoute() {
            return '/sithMes/agreement/agreementContent'
        }
    },
    props: {
        alwaysShowSwitch: {
            type: Boolean,
            default: false
        },
        initialMethodIsPassword: {
            type: Boolean,
            default: true
        },
        showPasswordLoginButton: {
            type: Boolean,
            default: false
        },
        identifyFor: {
            type: String,
            default: IDENTIFY_FOR.LOGIN
        }
    },
    data() {
        return {
            usingFace: !this.initialMethodIsPassword,
            cameraOpened: false,
            loginForm: {
                userRealName: '',
                mobilePhone: '',
                userId: '',
            },
            smsRequestForm: {
                mobilePhone: '',
                businessType: '',
            },
        }
    },
    methods: {
        userIdentified(userId) {
            //人脸登录才会验证手机
            if (this.identifyFor === IDENTIFY_FOR.LOGIN) {
                this.verifySMSCode(userId);
            } else {
                this.$emit('user-identified', userId);
            }
        },
        handleCameraOpened(cameraOpened) {
            this.cameraOpened = true
            this.$emit('camera-opened', cameraOpened);
        },
        openFromOutside() {
            if (this.$refs.faceLogin) {
                this.$refs.faceLogin.openFromOutside()
            }
        },
        getUserByPassword() {
            return this.$refs.passwordLogin.getUserByPassword()
        },
        resetPasswordLoginInfo() {
            if (this.$refs.passwordLogin) {
                this.$refs.passwordLogin.reset()
            }
        },
        resetFaceLoginInfo() {
            if (this.$refs.faceLogin) {
                this.$refs.faceLogin.reset()
            }
            this.cameraOpened = false
            this.usingFace = true
        },
        handleUsingPassword(usingPassword) {
            if (usingPassword) {
                this.usingFace = false
                this.cameraOpened = false
                this.$emit('usingFace', false)
                this.$emit('camera-opened', false);
            } else {
                this.usingFace = true
                this.$emit('usingFace', true)
            }
        },
        verifySMSCode(userId) {
            const self = this;
            self.loginForm.userId = userId;
            // 校验是否开启手机号校验,未开启普通登录
            this.$store.dispatch("api/post", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/emAdmSysParam/findValueByKey" + `?key=${self.checkPhoneKey}`,
            }).then((result) => {
                const valueData = result;
                if (valueData === undefined || valueData.data === null || valueData.data === false || valueData.status !== 200) {
                    self.$emit('user-identified', self.loginForm.userId);
                } else {
                    self.$store.dispatch("api/post", {
                        url: self.$store.state.emAclUser.baseModuleUrl + "/sso/checkPasswordAndPhone",
                        data: self.loginForm,
                    }).then((response) => {
                        const data = response.data
                        if (data) {
                            if (data.code !== 200) {
                                self.$store.dispatch("api/post", {
                                    url: self.$store.state.emAclUser.baseModuleUrl + "/emAdmSysParam/findValueByKey" + `?key=${self.forceCheckPhoneKey}`,
                                }).then((result) => {
                                    const valueData = result;
                                    // 校验是否强制手机号校验,查到配置并且为true才会抛错，否则走通常登录方法
                                    if (valueData && valueData.status === 200 && valueData.data === true) {
                                        self.$message({
                                            message: valueData.message,
                                            type: "error",
                                        });
                                    } else {
                                        self.$emit('user-identified', self.loginForm.userId);
                                    }
                                })
                            } else {
                                self.smsRequestForm.mobilePhone = data.data.emAclUser.telephone;
                                self.loginForm.mobilePhone = data.data.emAclUser.telephone;
                                self.loginForm.userRealName = data.data.emAclUser.name;
                                self.smsRequestForm.businessType = 'USER_LOGIN';
                                self.loginForm.businessType = 'USER_LOGIN';
                                self.$store.dispatch("api/post", {
                                    url: self.$store.state.emAclUser.baseModuleUrl + "/sso/sendVerifyCode",
                                    data: self.smsRequestForm,
                                }).then((response) => {
                                    const data = response.data
                                    if (data) {
                                        if (data.code !== 200) {
                                            self.passwordError = data.message;
                                            self.showPasswordError = true;
                                        } else {
                                            this.$refs.verificationCode.showModal()
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
</style>
